import React from 'react';
import {
	Card,
	Row,
	Col,
	Input,
	Button,
	Table,
	Modal,
	Form,
	Switch,
	DatePicker,
	message,
	Alert,
	Tag,
	Tooltip,
	Typography,
	Pagination,
	Descriptions,
} from 'antd';
import {
	SearchOutlined,
	PlusOutlined,
	FormOutlined,
	CloseSquareOutlined,
	ExclamationCircleOutlined,
	IdcardOutlined,
	RedoOutlined,
	CarOutlined,
	UndoOutlined,
	SaveOutlined,
	CloseCircleOutlined,
	CloseOutlined,
	CheckCircleOutlined,
} from '@ant-design/icons';
import moment from 'moment';

import { connect } from 'react-redux';
import {
	initHandler,
	ajaxViewHandler,
	ajaxHandler,
	setConfig,
} from "../../store/actions";

import Config from '../../Config';
import { Helmet } from "react-helmet";
import ErrorAlertModal from '../../components/ErrorAlertModal';

const { Text } = Typography;

const configClass = {
	title: 'Data IWKBU',
	apiUrl: {
		data: 'master/api/iwkbu/',
		kendaraan: 'kendaraan/api/kendaraan-kantor/',
		taskStatus: 'kendaraan/api/kendaraan-kantor/task-status/',
	},
	breadCrumb: [
		<span><IdcardOutlined /> Master</span>,
		'Data IWKBU',
	],
};

const config = new Config();

const FIELD_STYLE = {
	borderRadius: 8,
	height: 40,
};

class DataIwkbu extends React.Component {
	formRef = React.createRef();

	constructor(props) {
		super(props);
		this.state = {
			errMsg: '',
			errTitle: '',
			loadingData: false,
			loadingButton: false,
			loadingCek: false,
			pagination: { pageSize: 25, current: 1, total: 0 },
			searchText: '',
			dataSource: [],
			isMobile: window.innerWidth <= 768,

			modalVisible: false,
			editingRow: null,
			cariNopol: '',
			kendaraanFound: null,

			isMigrating: false,
			pollingInterval: null,
			pollingCount: 0,
			maxPollingAttempts: 15,
		};
		this._searchTimer = null;
	}

	UNSAFE_componentWillMount() {
		this.props.initHandler();
	}

	componentDidMount() {
		this.getData();
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
		clearTimeout(this._searchTimer);
		this.stopPolling();
	}

	async getData(limit = this.state.pagination.pageSize, offset = 0, search = this.state.searchText) {
		this.setState({ loadingData: true });
		this.props.ajaxViewHandler('get', configClass.apiUrl.data + '?limit=' + limit + '&offset=' + offset + '&search=' + search)
			.then(() => {
				const data = this.props.responseMsg;
				if (this.props.isSuccess) {
					this.setState(prev => ({
						dataSource: data.results,
						pagination: { ...prev.pagination, total: data.count },
					}));
				} else {
					this.setState({ errTitle: 'Gagal memuat data', errMsg: this.props.responseMsg });
					message.error({ content: 'Gagal memuat data', duration: 2, key: 'toast' });
				}
				this.setState({ loadingData: false });
			})
			.catch(() => {
				message.error({ content: 'Gagal request data, coba lagi', duration: 2, key: 'toast' });
				this.setState({ loadingData: false });
			});
	}

	handleSearchChange = (e) => {
		const val = e.target.value;
		this.setState({ searchText: val });
		clearTimeout(this._searchTimer);
		this._searchTimer = setTimeout(() => {
			this.setState(prev => ({ pagination: { ...prev.pagination, current: 1 } }));
			this.getData(this.state.pagination.pageSize, 0, val);
		}, 400);
	};

	handleTableChange = (pagination) => {
		this.setState({
			pagination: { ...this.state.pagination, pageSize: pagination.pageSize, current: pagination.current },
		});
		this.getData(pagination.pageSize, (pagination.current - 1) * pagination.pageSize);
	};

	handleMobilePageChange = (page, pageSize) => {
		this.setState(prev => ({ pagination: { ...prev.pagination, current: page, pageSize } }));
		this.getData(pageSize, (page - 1) * pageSize);
	};

	openAdd = () => {
		this.setState({
			modalVisible: true,
			editingRow: null,
			cariNopol: '',
			kendaraanFound: null,
		});
	};

	openEdit = (row) => {
		this.setState({
			modalVisible: true,
			editingRow: row,
			cariNopol: (row.nomor_polisi || '').replace(/^KH/i, ''),
			kendaraanFound: {
				nomor_rangka: row.nomor_rangka,
				nomor_mesin: row.nomor_mesin,
				pemilik: row.pemilik,
				pemilik_nama: row.pemilik_nama,
			},
		});
	};

	closeModal = () => {
		this.stopPolling();
		this.setState({ modalVisible: false, editingRow: null, isMigrating: false, pollingCount: 0 });
	};

	cekKendaraan = () => {
		const nopol = (this.state.cariNopol || '').trim();
		if (nopol === '') {
			message.warning({ content: 'Nomor polisi harus diisi', duration: 2, key: 'toast' });
			return;
		}
		this.setState({ loadingCek: true });
		message.loading({ content: 'Mencari data kendaraan...', duration: 0, key: 'cek' });
		this.props.ajaxViewHandler('get', configClass.apiUrl.kendaraan + '?nomor_polisi=KH' + nopol)
			.then(() => {
				const datas = this.props.responseMsg;

				if (datas && (datas.status === 'processing' || datas.detail)) {
					message.destroy('cek');
					message.info({
						content: datas.detail || 'Data sedang dimigrasi dari database lama. Mohon tunggu...',
						duration: 0,
						key: 'migration',
					});
					this.setState({ isMigrating: true, pollingCount: 0 });
					this.startPollingMigration(datas.task_id, nopol);
					return;
				}

				this.setState({ loadingCek: false });
				if (this.props.isSuccess) {
					if (!datas.results || datas.results.length === 0) {
						message.destroy('cek');
						message.error({ content: 'Nomor kendaraan tidak ditemukan', duration: 2, key: 'toast' });
						return;
					}
					message.destroy('cek');
					this.terapkanDataKendaraan(datas.results[0]);
				} else {
					message.destroy('cek');
					message.error({ content: 'Gagal mencari data kendaraan', duration: 2, key: 'toast' });
				}
			})
			.catch(() => {
				this.setState({ loadingCek: false });
				message.destroy('cek');
				message.error({ content: 'Gagal request data, coba lagi', duration: 2, key: 'toast' });
			});
	};

	terapkanDataKendaraan(data) {
		this.setState({
			kendaraanFound: {
				nomor_rangka: data.nomor_rangka,
				nomor_mesin: data.nomor_mesin,
				pemilik: data.pemilik,
				pemilik_nama: data.pemilik_nama,
			},
		});
		this.formRef.current.setFieldsValue({
			nomor_polisi: data.nomor_polisi,
			nomor_rangka: data.nomor_rangka,
			nomor_mesin: data.nomor_mesin,
			tanggal_notice_picker: data.tanggal_notice ? moment(data.tanggal_notice, 'YYYY-MM-DD') : null,
			sd_notice_picker: data.sd_notice ? moment(data.sd_notice, 'YYYY-MM-DD') : null,
			tanggal_swdkllj_picker: data.tanggal_notice ? moment(data.tanggal_notice, 'YYYY-MM-DD') : null,
			sd_swdkllj_picker: data.sd_notice ? moment(data.sd_notice, 'YYYY-MM-DD') : null,
		});
		message.success({ content: 'Data kendaraan ditemukan', duration: 2, key: 'toast' });
	}

	startPollingMigration = (taskId, nopol) => {
		this.stopPolling();
		const interval = setInterval(() => {
			const currentCount = this.state.pollingCount + 1;
			this.setState({ pollingCount: currentCount });
			this.checkMigrationStatus(taskId, nopol);

			if (currentCount >= this.state.maxPollingAttempts) {
				this.stopPolling();
				message.destroy('migration');
				message.error({ content: 'Timeout: pencarian data memakan waktu terlalu lama, coba lagi.', duration: 3, key: 'toast' });
				this.setState({ isMigrating: false, loadingCek: false });
			}
		}, 2000);
		this.setState({ pollingInterval: interval });
		this.checkMigrationStatus(taskId, nopol);
	};

	stopPolling = () => {
		if (this.state.pollingInterval) {
			clearInterval(this.state.pollingInterval);
			this.setState({ pollingInterval: null });
		}
	};

	checkMigrationStatus = (taskId, nopol) => {
		this.props.ajaxViewHandler('get', configClass.apiUrl.taskStatus + taskId + '/')
			.then(() => {
				const response = this.props.responseMsg;
				if (response.status === 'completed') {
					this.stopPolling();
					message.destroy('migration');
					this.setState({ isMigrating: false, pollingCount: 0, loadingCek: false });
					if (response.result && response.result.ok === false) {
						message.error({ content: 'Nomor kendaraan KH' + nopol + ' tidak ditemukan.', duration: 6, key: 'toast' });
					} else {
						message.success({ content: 'Data ditemukan, mengambil data kendaraan...', duration: 2, key: 'toast' });
						setTimeout(() => this.cekKendaraan(), 800);
					}
				} else if (response.status === 'failed') {
					this.stopPolling();
					message.destroy('migration');
					this.setState({ isMigrating: false, pollingCount: 0, loadingCek: false });
					message.error({ content: 'Pencarian data gagal, coba lagi.', duration: 3, key: 'toast' });
				}
			})
			.catch(() => { });
	};

	handleSubmit = (values) => {
		const { kendaraanFound, editingRow } = this.state;
		if (!kendaraanFound && !editingRow) {
			message.warning({ content: 'Cek data kendaraan terlebih dahulu sebelum menyimpan', duration: 2, key: 'toast' });
			return;
		}

		const payload = {
			nomor_polisi: values.nomor_polisi,
			nomor_rangka: values.nomor_rangka,
			nomor_mesin: values.nomor_mesin,
			tanggal_notice: values.tanggal_notice_picker ? values.tanggal_notice_picker.format('DD-MM-YYYY') : null,
			sd_notice: values.sd_notice_picker ? values.sd_notice_picker.format('DD-MM-YYYY') : null,
			tanggal_swdkllj: values.tanggal_swdkllj_picker ? values.tanggal_swdkllj_picker.format('DD-MM-YYYY') : null,
			sd_swdkllj: values.sd_swdkllj_picker ? values.sd_swdkllj_picker.format('DD-MM-YYYY') : null,
			tanggal_iwkbu: values.tanggal_iwkbu_picker ? values.tanggal_iwkbu_picker.format('DD-MM-YYYY') : null,
			pemilik: kendaraanFound ? kendaraanFound.pemilik : editingRow.pemilik,
			status: values.status,
		};

		this.setState({ loadingButton: true });
		message.loading({ content: 'Menyimpan...', key: 'toast' });

		const method = editingRow ? 'put' : 'post';
		const url = configClass.apiUrl.data + (editingRow ? editingRow.id + '/' : '');

		this.props.ajaxHandler(method, url, payload, false, true)
			.then(() => {
				this.setState({ loadingButton: false });
				if (this.props.isSuccess) {
					message.success({ content: 'Data IWKBU berhasil disimpan', duration: 2, key: 'toast' });
					this.closeModal();
					this.getData();
				} else {
					const errTitle = 'Gagal menyimpan data';
					message.error({ content: errTitle, duration: 2, key: 'toast' });
					this.setState({ errTitle, errMsg: this.props.responseMsg });
				}
			})
			.catch(() => {
				this.setState({ loadingButton: false });
				message.error({ content: 'Kesalahan pengiriman data, coba lagi', duration: 2, key: 'toast' });
			});
	};

	showDeleteConfirm(id) {
		Modal.confirm({
			title: 'Nonaktifkan Data IWKBU',
			icon: <ExclamationCircleOutlined />,
			content: 'Data IWKBU akan dinonaktifkan. Data tetap tersimpan dan dapat diaktifkan kembali.',
			okText: 'Nonaktifkan',
			okType: 'danger',
			cancelText: 'Batal',
			onOk: () => this.prosesHapus(id),
		});
	}

	prosesHapus(id) {
		message.loading({ content: 'Menonaktifkan...', key: 'toast' });
		this.props.ajaxHandler('delete', configClass.apiUrl.data + id + '/')
			.then(() => {
				if (this.props.isSuccess) {
					message.success({ content: 'Data IWKBU berhasil dinonaktifkan', duration: 2, key: 'toast' });
					this.getData();
				} else {
					message.error({ content: 'Gagal menonaktifkan data', duration: 2, key: 'toast' });
				}
			})
			.catch(() => {
				message.error({ content: 'Kesalahan pengiriman data, coba lagi', duration: 2, key: 'toast' });
			});
	}

	showRestoreConfirm(id) {
		Modal.confirm({
			title: 'Aktifkan Data IWKBU',
			icon: <UndoOutlined style={{ color: '#52c41a' }} />,
			content: 'Data IWKBU akan diaktifkan kembali.',
			okText: 'Aktifkan',
			okButtonProps: { style: { background: '#52c41a', borderColor: '#52c41a' } },
			cancelText: 'Batal',
			onOk: () => this.prosesRestore(id),
		});
	}

	prosesRestore(id) {
		message.loading({ content: 'Mengaktifkan...', key: 'toast' });
		this.props.ajaxHandler('post', configClass.apiUrl.data + id + '/restore/', {}, false, true)
			.then(() => {
				if (this.props.isSuccess) {
					message.success({ content: 'Data IWKBU berhasil diaktifkan kembali', duration: 2, key: 'toast' });
					this.getData();
				} else {
					message.error({ content: 'Gagal mengaktifkan data', duration: 2, key: 'toast' });
				}
			})
			.catch(() => {
				message.error({ content: 'Kesalahan pengiriman data, coba lagi', duration: 2, key: 'toast' });
			});
	}

	fmtTanggal(val) {
		if (!val) return '—';
		return moment(val, 'YYYY-MM-DD').format('DD-MM-YYYY');
	}

	_buildColumns() {
		return [
			{
				title: 'No',
				key: 'no',
				width: 56,
				align: 'center',
				render: (_, __, index) => {
					const { pagination } = this.state;
					return (
						<Text style={{ fontSize: 12, color: '#888' }}>
							{(pagination.current - 1) * pagination.pageSize + index + 1}
						</Text>
					);
				},
			},
			{
				title: 'Nomor Polisi',
				dataIndex: 'nomor_polisi',
				key: 'nomor_polisi',
				render: (value) => (
					<div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
						<div style={{
							width: 34, height: 34, borderRadius: 8,
							background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
							display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
						}}>
							<CarOutlined style={{ color: '#fff', fontSize: 15 }} />
						</div>
						<div style={{ fontWeight: 600, fontSize: 13, color: '#222' }}>{value || '—'}</div>
					</div>
				),
			},
			{
				title: 'Pemilik',
				dataIndex: 'pemilik_nama',
				key: 'pemilik_nama',
				render: (val) => val || <Text type="secondary">—</Text>,
			},
			{
				title: 'No. Rangka',
				dataIndex: 'nomor_rangka',
				key: 'nomor_rangka',
				render: (val) => val ? <span style={{ fontFamily: 'monospace', fontSize: 12 }}>{val}</span> : <Text type="secondary">—</Text>,
			},
			{
				title: 'No. Mesin',
				dataIndex: 'nomor_mesin',
				key: 'nomor_mesin',
				render: (val) => val ? <span style={{ fontFamily: 'monospace', fontSize: 12 }}>{val}</span> : <Text type="secondary">—</Text>,
			},
			{
				title: 'Tgl Notice',
				dataIndex: 'tanggal_notice',
				key: 'tanggal_notice',
				width: 110,
				render: (val) => this.fmtTanggal(val),
			},
			{
				title: 'SD Notice',
				dataIndex: 'sd_notice',
				key: 'sd_notice',
				width: 110,
				render: (val) => this.fmtTanggal(val),
			},
			{
				title: 'Tgl SWDKLLJ',
				dataIndex: 'tanggal_swdkllj',
				key: 'tanggal_swdkllj',
				width: 120,
				render: (val) => this.fmtTanggal(val),
			},
			{
				title: 'SD SWDKLLJ',
				dataIndex: 'sd_swdkllj',
				key: 'sd_swdkllj',
				width: 120,
				render: (val) => this.fmtTanggal(val),
			},
			{
				title: 'Tgl IWKBU',
				dataIndex: 'tanggal_iwkbu',
				key: 'tanggal_iwkbu',
				width: 110,
				render: (val) => this.fmtTanggal(val),
			},
			{
				title: 'Status',
				dataIndex: 'status',
				key: 'status',
				width: 110,
				align: 'center',
				render: (val) => val
					? <Tag style={{ borderRadius: 20, fontWeight: 600, fontSize: 11, background: '#f6ffed', borderColor: '#b7eb8f', color: '#389e0d' }}>Aktif</Tag>
					: <Tag style={{ borderRadius: 20, fontWeight: 600, fontSize: 11, background: '#fff1f0', borderColor: '#ffa39e', color: '#cf1322' }}>Non Aktif</Tag>,
			},
			{
				title: 'Aksi',
				key: 'aksi',
				width: 100,
				fixed: 'right',
				align: 'center',
				render: (_, row) => (
					<div style={{ display: 'flex', gap: 6, justifyContent: 'center' }}>
						<Tooltip title={row.deleted_at ? 'Aktifkan dulu untuk mengedit' : 'Edit'}>
							<Button size="small" shape="circle" type="primary" ghost disabled={!!row.deleted_at} onClick={() => this.openEdit(row)}>
								<FormOutlined />
							</Button>
						</Tooltip>
						{!row.deleted_at ? (
							<Tooltip title="Nonaktifkan">
								<Button size="small" shape="circle" danger onClick={() => this.showDeleteConfirm(row.id)}>
									<CloseSquareOutlined />
								</Button>
							</Tooltip>
						) : (
							<Tooltip title="Aktifkan kembali">
								<Button size="small" shape="circle"
									style={{ background: '#f6ffed', borderColor: '#52c41a', color: '#52c41a' }}
									onClick={() => this.showRestoreConfirm(row.id)}
								>
									<UndoOutlined />
								</Button>
							</Tooltip>
						)}
					</div>
				),
			},
		];
	}

	renderMobileCard(row) {
		return (
			<Card
				key={row.id}
				style={{ borderRadius: 14, marginBottom: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.07)', border: '1px solid #f0f0f0', overflow: 'hidden' }}
				bodyStyle={{ padding: 0 }}
			>
				<div style={{
					background: 'linear-gradient(135deg, #0f284711, #1e4d8a11)',
					borderBottom: '1px solid #d0dff5',
					padding: '12px 16px',
					display: 'flex', alignItems: 'center', gap: 12,
				}}>
					<div style={{
						width: 40, height: 40, borderRadius: 12,
						background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
						display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
					}}>
						<CarOutlined style={{ color: '#fff', fontSize: 18 }} />
					</div>
					<div style={{ flex: 1, minWidth: 0 }}>
						<div style={{ fontWeight: 700, fontSize: 14, color: '#0f2847', lineHeight: 1.3 }}>{row.nomor_polisi}</div>
						<div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>{row.pemilik_nama || '—'}</div>
					</div>
					{row.status
						? <Tag style={{ borderRadius: 20, fontSize: 11, margin: 0, background: '#f6ffed', borderColor: '#b7eb8f', color: '#389e0d', fontWeight: 600 }}>Aktif</Tag>
						: <Tag style={{ borderRadius: 20, fontSize: 11, margin: 0, background: '#fff1f0', borderColor: '#ffa39e', color: '#cf1322', fontWeight: 600 }}>Non Aktif</Tag>
					}
				</div>
				<div style={{ padding: '10px 16px' }}>
					<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
						<Text type="secondary" style={{ fontSize: 12 }}>Tgl Notice / SWDKLLJ</Text>
						<Text style={{ fontSize: 12 }}>{this.fmtTanggal(row.tanggal_notice)} / {this.fmtTanggal(row.tanggal_swdkllj)}</Text>
					</div>
					<div style={{ display: 'flex', justifyContent: 'space-between' }}>
						<Text type="secondary" style={{ fontSize: 12 }}>Tgl IWKBU</Text>
						<Text style={{ fontSize: 12 }}>{this.fmtTanggal(row.tanggal_iwkbu)}</Text>
					</div>
					<div style={{ display: 'flex', gap: 6, marginTop: 10 }}>
						<Button block size="small" icon={<FormOutlined />} disabled={!!row.deleted_at} onClick={() => this.openEdit(row)}>Edit</Button>
						{!row.deleted_at ? (
							<Button block size="small" danger icon={<CloseSquareOutlined />} onClick={() => this.showDeleteConfirm(row.id)}>Nonaktifkan</Button>
						) : (
							<Button block size="small" icon={<UndoOutlined />} onClick={() => this.showRestoreConfirm(row.id)}>Aktifkan</Button>
						)}
					</div>
				</div>
			</Card>
		);
	}

	render() {
		const {
			errMsg, errTitle, loadingData, loadingButton, loadingCek, dataSource, pagination,
			isMobile, searchText, modalVisible, editingRow, cariNopol, kendaraanFound, isMigrating,
		} = this.state;

		const isEdit = !!editingRow;
		const dataReady = !!kendaraanFound;

		return (
			<div>
				<Helmet>
					<title>{configClass.title + ' | ' + config.get_site_info().name}</title>
					<style>{`
						.data-iwkbu-wrap .ant-table-thead > tr > th {
							background: linear-gradient(135deg, #0f284711, #1e4d8a11) !important;
							font-weight: 700;
							font-size: 13px;
							color: #0f2847;
							border-bottom: 2px solid #d0dff5;
						}
						.data-iwkbu-wrap .ant-table-tbody > tr > td {
							padding: 12px 16px;
							vertical-align: middle;
						}
						.data-iwkbu-wrap .ant-table-tbody > tr:hover > td {
							background: #e8f0fb !important;
						}
						.data-iwkbu-wrap .ant-table-tbody > tr:nth-child(even) > td {
							background: #fafafa;
						}
						.data-iwkbu-wrap .ant-table-tbody > tr:nth-child(even):hover > td {
							background: #e8f0fb !important;
						}
						.data-iwkbu-wrap .row-nonaktif > td { opacity: 0.55; background: #fff9f9 !important; }
						.form-iwkbu-modal .ant-modal-content {
							border-radius: 16px;
							overflow: hidden;
							padding: 0;
							box-shadow: 0 12px 40px rgba(15,40,71,0.25);
						}
						.form-iwkbu-modal .ant-modal-body { padding: 0; }
						.form-iwkbu-modal .ant-form-item-label > label {
							font-weight: 600;
							color: #374151;
							font-size: 13px;
						}
						.form-iwkbu-modal .ant-input,
						.form-iwkbu-modal .ant-picker,
						.form-iwkbu-modal .ant-select-selector {
							border-radius: 8px !important;
						}
					`}</style>
				</Helmet>


				<ErrorAlertModal
					visible={errMsg !== ''}
					title={errTitle}
					error={errMsg}
					onClose={() => this.setState({ errTitle: '', errMsg: '' })}
				/>

				<Card
					className="data-iwkbu-wrap"
					style={{ borderRadius: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.07)', overflow: 'hidden' }}
					bodyStyle={{ padding: 0 }}
				>
					{/* Header */}
					<div style={{
						padding: '16px 20px',
						background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
						display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10,
					}}>
						<div>
							<div style={{ color: '#fff', fontWeight: 700, fontSize: 17 }}>
								<IdcardOutlined style={{ marginRight: 8 }} />
								{configClass.title}
							</div>
							<div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12, marginTop: 2 }}>
								Total {pagination.total || 0} data IWKBU terdaftar
								{loadingData && ' · Memuat...'}
							</div>
						</div>
						<div style={{ display: 'flex', gap: 8 }}>
							<Tooltip title="Refresh data">
								<Button
									onClick={() => {
										this.setState(
											prev => ({ searchText: '', pagination: { ...prev.pagination, current: 1 } }),
											() => this.getData(this.state.pagination.pageSize, 0, '')
										);
									}}
									icon={<RedoOutlined />}
									style={{ borderRadius: 8, background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff' }}
								>
									{!isMobile && 'Refresh'}
								</Button>
							</Tooltip>
							<Button
								type="primary"
								icon={<PlusOutlined />}
								onClick={this.openAdd}
								style={{ borderRadius: 8, background: '#fff', color: '#0f2847', border: 'none', fontWeight: 600 }}
							>
								{isMobile ? 'Tambah' : 'Tambah Data IWKBU'}
							</Button>
						</div>
					</div>

					{/* Search bar */}
					<div style={{
						padding: '12px 20px', borderBottom: '1px solid #f0f0f0', background: '#fff',
						display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap',
					}}>
						<Text type="secondary" style={{ fontSize: 12 }}>
							{loadingData ? 'Memuat data...' : `Menampilkan ${dataSource.length} dari ${pagination.total || 0} data`}
						</Text>
						<Input
							placeholder="Cari nomor polisi atau nama pemilik..."
							allowClear
							size="middle"
							prefix={<SearchOutlined style={{ color: '#bbb' }} />}
							style={{ borderRadius: 8, maxWidth: 340 }}
							value={searchText}
							onChange={this.handleSearchChange}
							onClear={() => {
								this.setState(
									prev => ({ searchText: '', pagination: { ...prev.pagination, current: 1 } }),
									() => this.getData(this.state.pagination.pageSize, 0, '')
								);
							}}
						/>
					</div>

					<div style={{ padding: isMobile ? 12 : 0 }}>
						{isMobile ? (
							<div>
								{loadingData ? (
									<div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>Memuat data...</div>
								) : dataSource.length === 0 ? (
									<div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>Tidak ada data</div>
								) : (
									dataSource.map(row => this.renderMobileCard(row))
								)}
								{pagination.total > 0 && (
									<div style={{ textAlign: 'center', padding: '12px 0 4px' }}>
										<Pagination
											current={pagination.current}
											pageSize={pagination.pageSize}
											total={pagination.total}
											onChange={this.handleMobilePageChange}
											showSizeChanger={false}
											simple
										/>
									</div>
								)}
							</div>
						) : (
							<Table
								columns={this._buildColumns()}
								dataSource={dataSource}
								loading={loadingData}
								rowKey="id"
								scroll={{ x: 'max-content' }}
								size="middle"
								rowClassName={(row) => row.deleted_at ? 'row-nonaktif' : ''}
								pagination={{
									current: pagination.current,
									pageSize: pagination.pageSize,
									total: pagination.total,
									showSizeChanger: true,
									pageSizeOptions: ['10', '25', '50', '100'],
									showTotal: (total, range) => `${range[0]}-${range[1]} dari ${total} data`,
								}}
								onChange={this.handleTableChange}
							/>
						)}
					</div>
				</Card>

				{/* Modal Tambah/Edit */}
				<Modal
					visible={modalVisible}
					onCancel={this.closeModal}
					footer={null}
					closable={false}
					destroyOnClose
					width={isMobile ? '94%' : 560}
					className="form-iwkbu-modal"
				>
					<Form
						layout="vertical"
						name="fiwkbu"
						ref={this.formRef}
						onFinish={this.handleSubmit}
						initialValues={editingRow ? {
							nomor_polisi: editingRow.nomor_polisi,
							nomor_rangka: editingRow.nomor_rangka,
							nomor_mesin: editingRow.nomor_mesin,
							tanggal_notice_picker: editingRow.tanggal_notice ? moment(editingRow.tanggal_notice, 'YYYY-MM-DD') : null,
							sd_notice_picker: editingRow.sd_notice ? moment(editingRow.sd_notice, 'YYYY-MM-DD') : null,
							tanggal_swdkllj_picker: editingRow.tanggal_swdkllj ? moment(editingRow.tanggal_swdkllj, 'YYYY-MM-DD') : null,
							sd_swdkllj_picker: editingRow.sd_swdkllj ? moment(editingRow.sd_swdkllj, 'YYYY-MM-DD') : null,
							tanggal_iwkbu_picker: editingRow.tanggal_iwkbu ? moment(editingRow.tanggal_iwkbu, 'YYYY-MM-DD') : null,
							status: editingRow.status,
						} : { status: true }}
					>
						{/* Header */}
						<div style={{
							background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
							padding: '20px 24px',
							display: 'flex', alignItems: 'center', gap: 16,
						}}>
							<div style={{
								width: 48, height: 48, borderRadius: 14,
								background: 'rgba(255,255,255,0.15)',
								display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
							}}>
								<IdcardOutlined style={{ color: '#fff', fontSize: 22 }} />
							</div>
							<div style={{ flex: 1, minWidth: 0 }}>
								<div style={{ color: '#fff', fontWeight: 700, fontSize: 17, lineHeight: 1.3 }}>
									{isEdit ? 'Edit Data IWKBU' : 'Tambah Data IWKBU'}
								</div>
								<div style={{ color: 'rgba(255,255,255,0.65)', fontSize: 12, marginTop: 2 }}>
									Cek nomor polisi untuk mengambil data kendaraan
								</div>
							</div>
							<Button shape="circle" icon={<CloseOutlined />} onClick={this.closeModal}
								style={{ background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff', flexShrink: 0 }} />
						</div>

						{/* Body */}
						<div style={{ padding: '24px 24px 8px', maxHeight: '65vh', overflowY: 'auto' }}>
							<Form.Item label="Nomor Polisi" required style={{ marginBottom: 8 }}>
								<Input.Group compact style={{ display: 'flex' }}>
									<Input
										addonBefore="KH"
										placeholder="cth: 1234XY"
										style={{ flex: 1, ...FIELD_STYLE }}
										value={cariNopol}
										onChange={(e) => this.setState({ cariNopol: e.target.value.toUpperCase() })}
										onPressEnter={this.cekKendaraan}
										disabled={isMigrating}
									/>
									<Button
										type="primary"
										icon={<SearchOutlined />}
										loading={loadingCek || isMigrating}
										onClick={this.cekKendaraan}
										style={{ borderRadius: 8, marginLeft: 8, background: '#1e4d8a', border: 'none' }}
									>
										Cek
									</Button>
								</Input.Group>
							</Form.Item>

							<Form.Item name="nomor_polisi" style={{ display: 'none' }}>
								<Input type="hidden" />
							</Form.Item>

							{dataReady ? (
								<Descriptions
									size="small"
									column={1}
									bordered
									style={{ marginBottom: 16, background: '#f6ffed', borderRadius: 8 }}
								>
									<Descriptions.Item label={<><CheckCircleOutlined style={{ color: '#52c41a' }} /> Pemilik</>}>
										{kendaraanFound.pemilik_nama || '—'}
									</Descriptions.Item>
								</Descriptions>
							) : (
								<Alert
									type="info"
									showIcon
									message="Belum ada data kendaraan"
									description="Masukkan nomor polisi lalu klik 'Cek' untuk mengambil data dari tabel kendaraan."
									style={{ marginBottom: 16, borderRadius: 8 }}
								/>
							)}

							<Row gutter={12}>
								<Col span={12}>
									<Form.Item label="No. Rangka" name="nomor_rangka">
										<Input disabled style={FIELD_STYLE} />
									</Form.Item>
								</Col>
								<Col span={12}>
									<Form.Item label="No. Mesin" name="nomor_mesin">
										<Input disabled style={FIELD_STYLE} />
									</Form.Item>
								</Col>
							</Row>

							<Row gutter={12}>
								<Col span={12}>
									<Form.Item label="Tanggal Notice" name="tanggal_notice_picker">
										<DatePicker disabled format="DD-MM-YYYY" style={{ width: '100%', ...FIELD_STYLE }} placeholder="dd-mm-yyyy" />
									</Form.Item>
								</Col>
								<Col span={12}>
									<Form.Item label="SD Notice" name="sd_notice_picker">
										<DatePicker disabled format="DD-MM-YYYY" style={{ width: '100%', ...FIELD_STYLE }} placeholder="dd-mm-yyyy" />
									</Form.Item>
								</Col>
							</Row>
							<Row gutter={12}>
								<Col span={12}>
									<Form.Item label="Tanggal SWDKLLJ" name="tanggal_swdkllj_picker">
										<DatePicker disabled format="DD-MM-YYYY" style={{ width: '100%', ...FIELD_STYLE }} placeholder="dd-mm-yyyy" />
									</Form.Item>
								</Col>
								<Col span={12}>
									<Form.Item label="SD SWDKLLJ" name="sd_swdkllj_picker">
										<DatePicker disabled format="DD-MM-YYYY" style={{ width: '100%', ...FIELD_STYLE }} placeholder="dd-mm-yyyy" />
									</Form.Item>
								</Col>
							</Row>

							<Row gutter={12}>
								<Col span={12}>
									<Form.Item
										label="Tanggal IWKBU"
										name="tanggal_iwkbu_picker"
										rules={[{ required: true, message: 'Tanggal IWKBU harus diisi' }]}
										style={{ marginBottom: 0 }}
									>
										<DatePicker format="DD-MM-YYYY" style={{ width: '100%', ...FIELD_STYLE }} placeholder="Pilih tanggal IWKBU" allowClear />
									</Form.Item>
								</Col>
							</Row>

							{editingRow && (
								<Descriptions
									size="small"
									column={1}
									style={{ marginTop: 16 }}
								>
									<Descriptions.Item label="Dibuat oleh">
										{editingRow.created_by_nama || '—'}
									</Descriptions.Item>
									<Descriptions.Item label="Diubah oleh">
										{editingRow.updated_by_nama || '—'}
									</Descriptions.Item>
								</Descriptions>
							)}
						</div>

						{/* Footer */}
						<div style={{
							padding: '16px 24px', marginTop: 4, display: 'flex', alignItems: 'center',
							justifyContent: 'space-between', borderTop: '1px solid #f0f0f0', background: '#fafafa',
						}}>
							<Form.Item name="status" valuePropName="checked" style={{ marginBottom: 0 }} label="Status Aktif">
								<Switch checkedChildren="Aktif" unCheckedChildren="Non Aktif" />
							</Form.Item>
							<div style={{ display: 'flex', gap: 10 }}>
								<Button icon={<CloseCircleOutlined />} onClick={this.closeModal} disabled={loadingButton} style={{ borderRadius: 10 }}>
									Batal
								</Button>
								<Button
									type="primary"
									htmlType="submit"
									icon={<SaveOutlined />}
									loading={loadingButton}
									style={{ borderRadius: 10, background: 'linear-gradient(135deg, #0f2847, #1e4d8a)', border: 'none', fontWeight: 600 }}
								>
									Simpan
								</Button>
							</div>
						</div>
					</Form>
				</Modal>
			</div>
		);
	}
}

const mapStateToProps = function (state) {
	return state.configReducers;
}

export default connect(
	mapStateToProps,
	{
		initHandler,
		setConfig,
		ajaxViewHandler,
		ajaxHandler,
	}
)(DataIwkbu);
